export const getBackendUrl = () => {
  // In Create React App with Vite, use import.meta.env
  // In Create React App, environment variables are injected at build time
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (!envUrl) {
    console.warn('REACT_APP_BACKEND_URL is not defined. Please set it in frontend/.env');
  }
  return envUrl || '';
};

export const apiGet = async (path) => {
  const base = getBackendUrl();
  // Ensure path begins with /api as per ingress rules
  const url = `${base}${path.startsWith('/api') ? path : `/api${path}`}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error(`GET ${url} failed: ${res.status}`);
  return res.json();
};
